<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless">
    <div class="column is-12 pdb-0">
      <a @click="$emit('togglePanier')">
        <b-icon class="icon is-pulled-right has-text-icon-more"
                icon="close"></b-icon>
      </a>
      <span class="mgl-10px has-text-weight-bold is-size-4">
          {{$t('listeProduitUnitaire.panierContent.panier')}}
        </span>
    </div>
    <div class="column is-12 pdb-0">
        <span class="mgl-10px is-size-6">
          {{ $t('listeProduitUnitaire.panierContent.sousTitle',
          { numberProduit: panierGetter.length }) }}
        </span>
    </div>
    <div class="column is-12 border-entete">
        <span class="mgl-10px is-size-6 has-text-weight-bold">
          {{$t('listeProduitUnitaire.panierContent.total')}}
        </span>
      <div class="is-pulled-right">
          <span class="is-size-6 has-text-weight-bold">
            {{ returnValeurPanier | formatDevise }}
          </span>
          <span class="is-size-6">
            {{ budgetMax }}
          </span>
      </div>
    </div>
    <div class="column is-12-tablet hauteur-panier is-marginless" v-if="panierGetter.length > 0">
      <div class="overflow-auto">
        <display-ligne-in-panier-face
          :panier="panierNewProduct"
          :isFacture="true"
          :isAlreadySelect="false"
          :title="panierNewProduct.length > 0 ?
          $t('listeProduitUnitaire.panierContent.newSelection') : ''"
          :info="panierNewProduct.length > 0 ? '' :
          $t('listeProduitUnitaire.panierContent.noNewProduct')">
        </display-ligne-in-panier-face>
        <display-ligne-in-panier-face v-if="panierProductFromDCF.length > 0"
                                      :isFacture="isFacture"
                                      :panier="panierProductFromDCF"
                                      class="mgt-20px"
                                      :isAlreadySelect="true"
                                      :title="$t('listeProduitUnitaire.panierContent.produitFromDCF'
                                      , { typeDCF: getType } )">
        </display-ligne-in-panier-face>
      </div>
    </div>
    <div class="column is-12 hauteur-panier is-flex" v-else>
      <div class="has-text-centered mg-auto">
        <div class="logo__panier_vide mg-auto"></div>
        <p class="has-text-weight-bold is-size-5">
          {{$t('listeProduitUnitaire.panierContent.panierVide')}}
        </p>
        <p>{{$t('listeProduitUnitaire.panierContent.noProduct')}}</p>
      </div>
    </div>
    <div class="column is-12 hauteur-bas-panier
    border-pied columns is-marginless is-vcentered level">
      <div class="level-left">
        <div class="column is-narrow"
             v-if="panierGetter.length > 1 && canMakeReseauPerso">
          <b-checkbox v-model="regroupementPersonnalise">
            <span class="has-text-default is-size-6">
              {{$t('listeProduitUnitaire.panierContent.reseauPerso')}}
            </span>
          </b-checkbox>
        </div>
      </div>
      <button class="button pdv-0 column is-narrow pdh-20px
      level-right"
              :class="[{'is-select pointer-events-none': panierGetter.length === 0},
        {'is-addOrEdit': panierGetter.length > 0}]" @click="ajoutLignesALaCommande()">
        {{$t('listeProduitUnitaire.panierContent.add')}}
      </button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { formatDevise } from '@/services/general/filters/formatDevise';
import {
  TYPE_COMMANDE,
  TYPE_FACTURE,
  ETAT_FACTURE,
  ETAT_FACTURE_PARTIELLEMENT,
} from '@/configuration/devisConf';
import { SET_REGROUPEMENT_PERSONNALISE, SET_USE_ECRAN_AJOUT } from '@/store/modules/produitFace-mutation-type';
import { CATEGORIE_LOCATION } from '@/configuration/catalogue/produitConf';
import displayLigneInPanierFace from './displayLigneInPanierFace';

const Commande = createNamespacedHelpers('commande');
const ProduitFace = createNamespacedHelpers('produitFace');

export default {
  props: {
    canMakeReseauPerso: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    displayLigneInPanierFace,
  },
  computed: {
    ...ProduitFace.mapGetters({
      briefStocke: 'brief',
      panierGetter: 'panier',
      typeDCF: 'typeDCF',
    }),
    ...Commande.mapGetters({
      commandeCourante: 'commande',
      messageErrorRegroupement: 'messageErrorRegroupement',
    }),
    regroupementPersonnalise: {
      set(value) {
        this.setGegroupementPersonnalise(value);
      },
      get() {
        return this.getRegroupementPersonnalise;
      },
    },
    isFacture() {
      return !!(this.commandeCourante.etat === ETAT_FACTURE
        || this.commandeCourante.etat === ETAT_FACTURE_PARTIELLEMENT);
    },
    getType() {
      switch (this.typeDCF) {
        case TYPE_COMMANDE:
          return this.$i18n.t('listeProduitUnitaire.panierContent.type.commande');
        case TYPE_FACTURE:
          return this.$i18n.t('listeProduitUnitaire.panierContent.type.facture');
        default:
          return this.$i18n.t('listeProduitUnitaire.panierContent.type.devis');
      }
    },
    panierNewProduct() {
      this.loadLogoPanier(true);
      return this.panierGetter.filter((ligne) => { return !ligne.isAlreadySelect; });
    },
    panierProductFromDCF() {
      this.loadLogoPanier(true);
      return this.panierGetter.filter((ligne) => { return ligne.isAlreadySelect; });
    },
    returnValeurPanier() {
      let prix = 0;
      this.panierGetter.forEach((ligne) => {
        ligne.lignesCommande.forEach((ligneCommande) => {
          prix += ligneCommande.totalHt && ligneCommande.typeProduit === CATEGORIE_LOCATION
            ? ligneCommande.totalHt : 0;
        });
      });
      return prix;
    },
    budgetMax() {
      if (this.briefStocke.budgetMax) return `/ ${formatDevise(this.briefStocke.budgetMax)}`;
      return '';
    },
  },
  methods: {
    ...ProduitFace.mapActions({
      loadLogoPanier: 'loadLogoPanier',
    }),
    ...ProduitFace.mapMutations({
      setGegroupementPersonnalise: SET_REGROUPEMENT_PERSONNALISE,
      setUseEcranAjout: SET_USE_ECRAN_AJOUT,
    }),
    ajoutLignesALaCommande() {
      this.setUseEcranAjout(true);
      if (this.panierGetter.length === 1) this.regroupementPersonnalise = false;
      this.$emit('ajouterLigneToCommande');
    },
  },
  mounted() {
    this.regroupementPersonnalise = false;
  },
};
</script>
